import React from 'react';
import { connect } from 'react-redux';
import { Button, Col, Input, Row, Tab, Tabs } from 'react-bootstrap';
import { I18n, Translate } from 'react-redux-i18n';
import { addProductFiles, addProductImages, addProductRequests, removeProductFiles, removeProductImages } from '../../../actions/sales_actions';
import axios from 'axios';
import { MFG_ORDER_UPLOAD } from '../../../actions/url';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'scroll'
  },
  uploaderWrapper: {
    width: '20%',
    height: '10vw',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #000000'
  },
  uploaderDcWrapper: {
    width: '20%',
    height: '10vw',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #DCDCDC'
  },
  uploader: {
    width: '100%',
    height: '100%',
    opacity: 0,
    position: 'absolute',
    zIndex: '100',
  },
  uploadIcon: {
    fontSize: '44px',
    color: '#000000',
  },
  uploadDCIcon: {
    fontSize: '44px',
    color: '#C5C5C5',
  }
}
const Image = props => {
  const styles = {
    container: {
      width: '200px',
      border: '1px solid #DCDCDC',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      marginBottom: '10px',
    },
    image: {
      width: '200px',
      height: '200px',
    },
    title: {},
    removeBtn: {
      position: 'absolute',
      right: '10px',
      top: '10px'
    }
  }
  return <div style={styles.container}>
    <img style={styles.image} src={props.url} alt=""/>
    <span style={styles.title}>{props.name}</span>
    <div style={styles.removeBtn} 
    onClick={()=>{props.remove(props.index)}}
    >
      <i className="fa fa-remove" />
    </div>
  </div>
}
const File = props => {
  const styles = {
    container: {
      width: '150px',
      border: '1px solid #DCDCDC',
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      marginBottom: '10px',
    },
    fileIcon: {
      fontSize: '40px'
    },
    title: {},
    removeBtn: {
      position: 'absolute',
      right: '10px',
      top: '10px'
    }
  }
  const handleClickFile = () => {
    window.open(props.url)
  }
  const handleRemoveFile = evt => {
    evt.stopPropagation();
    props.onRemove()
  }
  return <div style={styles.container} onClick={() => handleClickFile()}>
    <i className="fa fa-file" style={styles.fileIcon} />
    <span style={styles.title}>{props.name}</span>
    <div style={styles.removeBtn} onClick={handleRemoveFile}>
      <i className="fa fa-remove" />
    </div>
  </div>
}
class OrderRequestsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      value: '',
    }
    this.labelInput = null;
    this.valueInput = null;
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.currentProductRequests != this.props.currentProductRequests || !this.state.value) {
      this.setState({
        value: nextProps.currentProductRequests || '',
      })
    }
  }

  handleRequestLabelInput = evt => {
    this.setState({
      name: evt.target.value,
    })
  }
  handleRequestValueInput = evt => {
    this.setState({
      value: evt.target.value,
    })
  }
  handleAddRequestClick = (e) => {
    this.props.addProductRequests(e.target.value);
  }
  handleTabSwitch = tabIndex => {
    this.setState({
      activeTab: tabIndex,
    })
  }

  // 上传文件
  handleUpload = ({target: {files}}, isFile = false) => {
    const data = new FormData();
    data.append('File', files[0]);
    axios.post(MFG_ORDER_UPLOAD, data, {headers: { 'Content-Type': 'multipart/form-data' }}).then(response => {
      if (response.data.url) {
        if(isFile) {
          this.props.addProductFiles(files[0].name, response.data.url)
        } else {
          this.props.addProductImages(files[0].name, response.data.url)
        }
      }
    });
  }

  render() {
    const { disabled, currentProductRequests, currentProductImages, currentProductFiles } = this.props;
    return <Row>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <h2><Translate value="order_request"/></h2>
        <div
          style={{
            marginRight: '4px',
            position: 'relative',
            zIndex: 99
          }}
        >{
          this.state.isProductInformationPanelFolded
            ? <i className={'fa fa-plus'}/>
            : <i className={'fa fa-minus'}/>
        }
        </div>
      </div>
      <Tabs activeKey={this.state.activeTab} justified onSelect={this.handleTabSwitch}>
        <Tab eventKey={1} title={<Translate value={'product_request'} />}>
          <Row>
            <Col xs={12}>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                
              }}>
                <textarea
                  type="text"
                  ref={ref => this.valueInput = ref}
                  value={this.state.value}
                  disabled={disabled}
                  onChange={this.handleAddRequestClick}
                  style={{
                    marginTop: -10,
                    marginLeft: 10,
                    width: '300px',
                    height: '60px',
                  }}
                  // onKeyPress={evt => {
                  //   if (evt.key === 'Enter' && this.state.value) {
                  //     this.handleAddRequestClick();
                  //   }
                  // }}
                />
              </div>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey={2} title={<Translate value={'images'}/>}>
          <Row>
            <Col xs={12}>
              <div style={styles.container}>
                {currentProductImages.map((image, index) => <Image name={image.name} url={image.url} index={index} key={index} remove={this.props.removeProductImages}/>)}
                <div id="uploaderWrapper" style={disabled ? styles.uploaderDcWrapper : styles.uploaderWrapper}>
                  <i className={'fa fa-upload'} style={disabled ? styles.uploadDCIcon : styles.uploadIcon}/>
                  <input type={'file'} style={styles.uploader} disabled={disabled} onChange={(e) => {this.handleUpload(e)}}/>
                </div>
              </div>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey={3} title={<Translate value={'files'}/>}>
          <Row>
            <Col xs={12}>
              <div style={styles.container}>
                {currentProductFiles.map(file => <File name={file.name} url={file.url} onRemove={this.props.removeProductFiles}/>)}
                <div id="uploaderWrapper" style={disabled ? styles.uploaderDcWrapper : styles.uploaderWrapper}>
                  <i className={'fa fa-upload'} style={disabled ? styles.uploadDCIcon : styles.uploadIcon}/>
                  <input type={'file'} style={styles.uploader} disabled={disabled} onChange={(e)=> {this.handleUpload(e, true)}}/>
                </div>
              </div>
            </Col>
          </Row>
        </Tab>
      </Tabs>
    </Row>
  }
}

const mapStateToProps = state => {
  return {
    currentProductRequests: state.salesOrders.currentProductRequests,
    currentProductImages: state.salesOrders.currentProductImages,
    currentProductFiles: state.salesOrders.currentProductFiles,
  }
}
const mapDispatchToProps = {
  addProductRequests,
  addProductImages,
  removeProductImages,
  addProductFiles,
  removeProductFiles,
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderRequestsContainer);



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/OrderRequests.jsx